// Expose public Images assets via PUBLIC_URL for reliable runtime paths
const base = process.env.PUBLIC_URL + '/Images';

export const about = `${base}/about.png`;

export const icons = {
  b_logo: `${base}/icons/b_logo.svg`,
  channeli_logo: `${base}/icons/channeli_logo.svg`,
  appetizer_logo: `${base}/icons/appetizer_logo.jpeg`,
};

export default { about, icons };
